export let OAuthProviders;

(function (OAuthProviders) {
  OAuthProviders["Microsoft"] = "microsoft";
  OAuthProviders["Google"] = "google";
})(OAuthProviders || (OAuthProviders = {}));